import Vue from "vue";
import "../assets/styles/style.scss";
import Vuetify from "vuetify/lib";
import it from 'vuetify/es5/locale/it';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { it },
    current: 'it',
  },
  theme: {
    themes: {
      light: {
        primary: "#222",
        secondary: "#777",
        accent: "#777",
        success: "#222"
      }
    }
  }
});
